import React from 'react';
import { TextAnalyzer } from '../components/text-analyzer/TextAnalyzer';
import '../components/text-analyzer/TextAnalyzer.css';

export const TextAnalyzerPage: React.FC = () => {
  return (
    <div className="page-container">
      <TextAnalyzer />
    </div>
  );
};
